module.exports = __webpack_public_path__ + "img/main_mockup@2x.cca4224e.png";